import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d11c1d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopinfo-wrap" }
const _hoisted_2 = { class: "shopinfo-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "shopinfo-right-box" }
const _hoisted_5 = { class: "shopinfo-name-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "全部商品999", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.store)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "item-container",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.modelValue.backgroundImage + ')' })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.store.logo
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.store.name), 1),
              _hoisted_6
            ])
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}